export type EventHandler<T extends string, G extends Record<string,any>> = (data: G[T]) => void;


export type GeneralEventData<T extends string, A extends {} = {}> = {
    type: T;
} & A;

export class EventEmitter<T extends string, G extends Record<string, GeneralEventData<T>>> {
    private eventHandlersMap: Record<string, any> = {};

    subscribe<T extends string>(eventType: T, handler: EventHandler<T, G>) {
        if (!this.eventHandlersMap[eventType]) {
            this.eventHandlersMap[eventType] = [];
        }
        this.eventHandlersMap[eventType].push(handler);
    }

    unsubscribe<T extends string>(eventType: T, targetHandler: EventHandler<T, G>) {
        const handlers = this.eventHandlersMap[eventType];
        if (handlers) {
            this.eventHandlersMap[eventType] = handlers.filter((handler: any) => handler !== targetHandler);
        }
    }

    dispatch(eventData: G[T]) {
        const handlers = this.eventHandlersMap[eventData.type];
        if (handlers) {
            handlers.forEach((handler: any) => handler(eventData));
        }
    }
}
